import React, { Component } from "react";
import { ModuleAccordionGroup, LOAN_STATUSES } from "@loanbossinc/component-library";
import moment from "moment";
import { AccordionSection } from "component-lib/AccordionSection";
import { rows } from './loan-prepayment-schedule-rows';
import { LOAN_SECTION_KEYS } from '../loan.constants';

// EXTENSIONS WILL HAVE TO GET AN OPTIONAL PARAM!!!!! because the section key is built
// partially by the index value for each extension. the form builder will have to premap the values
// so that it only grabs the one extension

export class LoanPrepaymentSchedule extends Component {
  mapPrepaymentSchedules = () => {
    const { data, history, loanId, enableEditButton, ...other } = this.props;
    if (!data || !data.prepaymentSchedules) return null;

    const groupsArray = [
      {
        title: 'Prepayment Schedules'
        , key: LOAN_SECTION_KEYS.LOAN_PREPAYMENT_SCHEDULE
        , isTitleGroup: true
        , isExpandable: false
      }
    ];
    const quoteStatuses = [LOAN_STATUSES.QUOTE,LOAN_STATUSES.REJECTED_QUOTE,LOAN_STATUSES.PASSED_QUOTE,LOAN_STATUSES.WINNING_QUOTE];
    const isQuote = quoteStatuses.some(status => status === data.loanStatusId);

    let groups = data.prepaymentSchedules.reduce((accum, prepaymentSchedule) => {
      if (!prepaymentSchedule) return accum;
      prepaymentSchedule.isQuote = isQuote;
      accum.push({
          title: `${(prepaymentSchedule && prepaymentSchedule.prepaymentType && prepaymentSchedule.prepaymentType.value) || ""} `
        , subTitle: this.getSubTitle(prepaymentSchedule)
        , sortOrder: prepaymentSchedule.sortOrder
        , key: `${LOAN_SECTION_KEYS.LOAN_PREPAYMENT_SCHEDULE}-${prepaymentSchedule.sortOrder}`
        , isTitleGroup: false
        , isExpandable: true
        , buttonLabel: 'Edit Details'
        , showEditButton: enableEditButton
        , onClick: () => history.push(`/loans/${loanId}/edit/${LOAN_SECTION_KEYS.LOAN_PREPAYMENT_SCHEDULE}/${prepaymentSchedule.id}`)
        , sections: [<AccordionSection eventHandlers={this.props.eventHandlers} rows={rows(isQuote)} data={prepaymentSchedule} />]
      });
      return accum;

    }, groupsArray);

    groups = groups.sort((a, b) => a.sortOrder - b.sortOrder);

    // add new row button
    groups.push({
      isButton: true
      , key: `schedule-add-button`
      , buttonLabel: 'Add new schedule'
      , showEditButton: enableEditButton
      , onClick: () => history.push(`/loans/${loanId}/edit/${LOAN_SECTION_KEYS.LOAN_PREPAYMENT_SCHEDULE}/new/${data.prepaymentSchedules ? data.prepaymentSchedules.length : 0}`)
    });

    return groups;
  }

  getSubTitle = (prepaymentSchedule) => {
    if(!prepaymentSchedule.begin || !prepaymentSchedule.end) return null;
    
    const start = moment.utc(prepaymentSchedule.begin).format('MMM D, YYYY');
    const end = moment.utc(prepaymentSchedule.end).format('MMM D, YYYY');

    return `${start} - ${end}`;
  }

  render() {
    const groups = this.mapPrepaymentSchedules();
    const { data, ...other } = this.props;

    return <ModuleAccordionGroup {...other} groups={groups} />;
  }
}
